// extracted by mini-css-extract-plugin
export var deleteIcon = "_ts-5";
export var deleteOption = "_ts-3";
export var divider = "_ts-2";
export var downloadIcon = "_ts-4";
export var drawer = "_ts-0";
export var drawerFooter = "_ts-6";
export var drawerOpen = "_ts-1";
export var highlighted = "_ts-7";
export var lighterHighlight = "_ts-8";